/* ============================================================
   BOND custom JS for Shopify Dawn
   - Intercepts BOND "Add to cart" buttons ([data-bond-add])
   - Adds the selected/default variant via the Cart AJAX API
   - Renders into Dawn's existing cart drawer / cart notification
   - Falls back to the /cart page if no drawer element exists
   ============================================================ */
(function () {
  function getCartElement() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-bond-add]');
    if (!form) return;
    e.preventDefault();

    var idInput = form.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) return;

    var btn = form.querySelector('button[type="submit"]');
    var originalText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Addingâ€¦'; }

    var cart = getCartElement();
    var body = { id: Number(idInput.value), quantity: 1 };

    // Ask Shopify to return the section HTML Dawn's drawer needs to refresh
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        // Shopify returns a "status" field only on error (e.g. sold out)
        if (res && res.status) {
          if (btn) { btn.textContent = originalText; btn.disabled = false; }
          return;
        }
        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(res); // updates + opens Dawn's drawer/notification
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        if (btn) {
          btn.textContent = 'Added';
          setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 1400);
        }
      })
      .catch(function () {
        if (btn) { btn.textContent = originalText; btn.disabled = false; }
        window.location = (window.routes && window.routes.cart_url) || '/cart';
      });
  });
})();